export const YM_HIDE_CONTENT = 'ym-hide-content';
